const ITEMS = [
  "98.4% ATS PASS RATE",
  "3× MORE INTERVIEW CALLBACKS",
  "WRITTEN BY UK HR PROFESSIONALS",
  "BUILT FOR INTERNATIONAL STUDENTS",
  "HEADQUARTERED IN SHEFFIELD, UK",
  "ALIGNED TO UK GMT HOURS",
  "SECURE GBP CHECKOUT",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-[#C5A059]/30 bg-[#C5A059]" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center py-3.5">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-xs font-medium tracking-[0.25em] text-[#0A0F1D]">
            <span className="px-8">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#0A0F1D]/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
